module.exports = "/_next/static/images/PowerPersonalization-d30b08c65bf5c895c0b17e35afb611a6.webp";